import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Icon, Text } from '@chakra-ui/react';
export const RestrictedGovtMastheadItem = ({ icon, header, children, }) => {
    return (_jsxs(Flex, { flex: 1, maxW: "32rem", children: [_jsx(Icon, { "aria-hidden": true, as: icon, fontSize: { base: '1rem', lg: '1.5rem' }, mr: { base: '0.5rem', lg: '0.75rem' } }), _jsxs(Flex, { flexDir: "column", children: [_jsx(Text, { textStyle: { base: 'caption-1', lg: 'subhead-1' }, mb: "0.75rem", children: header }), children] })] }));
};
